import { render, staticRenderFns } from "./APSettings.vue?vue&type=template&id=056eef8c&"
import script from "./APSettings.vue?vue&type=script&lang=js&"
export * from "./APSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports